type FeedbackErrorMessageName =
  | 'INCLUDES_SWEDISH_LETTERS'
  | 'ARTICLE_NOT_FOUND_BY_SCANNED_EAN_NUMBER'
  | 'EAN_NUMBER_NOT_SCANNED'
  | 'IS_EMPTY_SERIAL_NUMBER'
  | 'INVALID_SERIAL_NUMBER_FORMAT'
  | 'DUPLICATE_SERIAL_NUMBER_IN_STATE'
  | 'DUPLICATE_SERIAL_NUMBER_IN_PARSED_INPUT'
  | 'TRACE_SUBMISSION_ERROR'
  | 'BATTERY_API_CALL_FAILED'

type FeedbackSuccessMessageName = 
  | 'TRACE_SUBMISSION_SUCCESS'
  | 'INFORMATION_MESSAGE_SUCCESS'

export interface FeedbackErrorMessage {
  type: 'error'
  name: FeedbackErrorMessageName
  message: string
}

export interface FeedbackSuccessMessage {
  type: 'success'
  name: FeedbackSuccessMessageName
  message: string
}

export type FeedbackMessageErrorMapping = {
  [key in FeedbackErrorMessageName]: FeedbackErrorMessage
}

export type FeedbackMessageSuccessMapping = {
  [key in FeedbackSuccessMessageName]: FeedbackSuccessMessage
}

export interface FeedbackMessageMapping extends FeedbackMessageErrorMapping, FeedbackMessageSuccessMapping {}

export const FEEDBACK_MESSAGE_SUCCESS_MAPPING: FeedbackMessageSuccessMapping = {
  TRACE_SUBMISSION_SUCCESS: {
    type: 'success',
    name: 'TRACE_SUBMISSION_SUCCESS',
    message: 'You have successfully submitted traces',
  },
  INFORMATION_MESSAGE_SUCCESS: {
    type: 'success',
    name: 'INFORMATION_MESSAGE_SUCCESS',
    message: 'Article number added succesfully, please scan serial number to continue',
  },
}

export const FEEDBACK_MESSAGE_ERROR_MAPPING: FeedbackMessageErrorMapping = {
  INCLUDES_SWEDISH_LETTERS: {
    type: 'error',
    name: 'INCLUDES_SWEDISH_LETTERS',
    message: 'Scanned input includes Swedish characters. Please switch to American keyboard input source.',
  },
  ARTICLE_NOT_FOUND_BY_SCANNED_EAN_NUMBER: {
    type: 'error',
    name: 'ARTICLE_NOT_FOUND_BY_SCANNED_EAN_NUMBER',
    message: 'Failed to find article by scanned EAN number.',
  },
  EAN_NUMBER_NOT_SCANNED: {
    type: 'error',
    name: 'EAN_NUMBER_NOT_SCANNED',
    message: 'Failed to scan serial numbers due to missing EAN code.',
  },
  IS_EMPTY_SERIAL_NUMBER: {
    type: 'error',
    name: 'IS_EMPTY_SERIAL_NUMBER',
    message: 'One or many serials scanned were empty.',
  },
  INVALID_SERIAL_NUMBER_FORMAT: {
    type: 'error',
    name: 'INVALID_SERIAL_NUMBER_FORMAT',
    message: 'One or many serials scanned had an incorrect format.',
  },
  DUPLICATE_SERIAL_NUMBER_IN_STATE: {
    type: 'error',
    name: 'DUPLICATE_SERIAL_NUMBER_IN_STATE',
    message: 'One or many serials scanned has already been processed.',
  },
  DUPLICATE_SERIAL_NUMBER_IN_PARSED_INPUT: {
    type: 'error',
    name: 'DUPLICATE_SERIAL_NUMBER_IN_PARSED_INPUT',
    message: 'Found duplicate serials in scanned input.',
  },
  TRACE_SUBMISSION_ERROR: {
    type: 'error',
    name: 'TRACE_SUBMISSION_ERROR',
    message: 'Failed to submit traces, please contact support if error persists.',
  },
  BATTERY_API_CALL_FAILED: {
    type: 'error',
    name: 'BATTERY_API_CALL_FAILED',
    message: 'Battery change API failed or permission not granted for this user-role. Please reach out to BEAM team.',
  },
}
